@use "../../styles/breakpoint.module.scss" as *;
@use "./Header.module" as *;

.mainNav {
    position: sticky;
    top: 0;
    z-index: 10;
    height: $main-nav-height;
    translate: 0 0;
    transition:
        translate 0.3s ease-in-out,
        background-color 0.3s ease-in-out,
        color 0.3s ease-in-out;
}

.hidden {
    translate: 0 -100%;
}

// must be this instead of display: none to make collision detection with
// the logo work as expected
.hideDesktop {
    position: absolute;
    width: 100%;
    visibility: hidden;
    pointer-events: none;
}

.inner {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    gap: var(--spacer-24);
}

.logo {
    position: absolute;
    left: 0;
    font-size: 0;
}

.logoSvg {
    width: 87px;
    height: auto;
    fill: currentcolor;
}

.menuItems {
    display: flex;
    align-items: center;
    gap: var(--spacer-24);

    @media print {
        display: none;
    }
}

.searchTrigger {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--spacer-32);
    height: var(--spacer-32);
    color: inherit;
}

.layoutUnset {
    @media ($below-mobile) {
        position: absolute;
        width: 100%;
        visibility: hidden;
        pointer-events: none;
    }

    @media ($above-mobile) {
        opacity: 0;
    }
}

.layoutSet {
    opacity: 1;
}

.searchTriggerIcon {
    width: var(--spacer-24);
    height: var(--spacer-24);
    fill: currentcolor;
}
